module.exports = __webpack_public_path__ + "img/pushgaming.bc327a22.svg";